import { AssetId } from '~modules/media-library/model/Asset';
import { ConfirmDelete } from '~modules/media-library/view/Contribute/ConfirmDelete/ConfirmDelete';

type ConfirmDeleteControllerProps = {
  assetId: AssetId;
  onClose?: () => void;
  onDeleteSuccess?: () => void;
};

export function ConfirmDeleteController({ assetId, onClose, onDeleteSuccess }: ConfirmDeleteControllerProps) {
  return <ConfirmDelete assetId={assetId} onClose={onClose} onDeleteSuccess={onDeleteSuccess} />;
}
